import { useEffect, useState } from "react";
import Picker, { SliderPickerProps } from "../Picker";

type SetTimeProps = {
  pickers: {
    type: SliderPickerProps["options"]["type"];
    onChangePicker(value: number): void;
    value: string;
    isInf?: boolean
    disabled?: boolean
  }[];
  style?: React.CSSProperties | undefined;
};

function SetTime(props: SetTimeProps) {
  useEffect(() => { }, []);

  return (
    <div style={props.style} className="text-center">
      <div className="text-white font-bold text-3xl text-center mb-2">
        Set Time
      </div>
      <div className="grid grid-cols-3 gap-3 ml-20">
        {props.pickers.map((item, index) => (
          <div className="w-32 border-2 border-white rounded-3xl bg-quickStartLeftStepContentBgColor" key={index}>
            <Picker
              key={index}
              options={{
                type: item.type,
                cb: (value) => {
                  const newValue = value === "∞" ? -1 : Number(value);
                  item.onChangePicker(newValue)
                },
                defaultValue: item.value === "-1" ? "∞" : item.value,
                isInf: item.isInf,
                disabled: item.disabled,
              }}
            />
          </div>
        ))}
        <div className="w-32 font-bold text-3xl text-white">Days</div>
        <div className="w-32 font-bold text-3xl text-white">Hours</div>
        <div className="w-32 font-bold text-3xl text-white">Minutes</div>
      </div>
    </div>
  );
}
export default SetTime;
